import { observer } from 'mobx-react-lite';
import { Menubar } from 'primereact/menubar';
import { ApplicationSdk } from '../../stores';


const Navigation = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const end = <img alt="logo" src="/Logo.svg" height="40" className="mr-2" style={{ marginRight: 16 }}></img>;

    return <Menubar end={end} model={[
        {
            label: 'Bestellungen',
            id: 'orders',
            icon: 'pi pi-truck',
            command: () => {
                sdk.routeTo('/edit/orders');
            }
        },
        {
            label: 'Objekte',
            id: 'objects',
            icon: 'pi pi-box',
            command: () => {
                sdk.routeTo('/edit/objects');
            },
            right: 'MANAGE_OBJECTS'
        },
        {
            label: 'Produkte',
            id: 'products',
            icon: 'pi pi-shop',
            command: () => {
                sdk.routeTo('/edit/products');
            },
            right: 'MANAGE_PRODUCTS'
        },
        {
            label: 'Reinigungskräfte',
            id: 'cleaner',
            icon: 'pi pi-users',
            command: () => {
                sdk.routeTo('/edit/cleaner');
            },
            right: 'MANAGE_CLEANER'
        },
        {
            label: 'Objektleiter',
            id: 'manager',
            icon: 'pi pi-briefcase',
            command: () => {
                sdk.routeTo('/edit/manager');
            },
            right: 'MANAGE_MANAGER'
        },
        {
            label: 'Schulungen',
            id: 'training',
            icon: 'pi pi-book',
            command: () => {
                sdk.routeTo('/edit/training');
            },
            right: 'MANAGE_TRAINING'
        }
    ].filter((item: any) => !item.right || sdk.user?.hasRight(item.right)).map((item: any) => ({
        ...item,
        className: sdk.locationAction === item.id ? "p-focus" : "",
    }))} />
});


export default Navigation;